import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from '../lib/keaConnect'
import WP from '@otavamedia/om-component-library/lib/lib/WP'
import { FishPin, ElkPin, DeerPin } from '../components/widgets/Icons'
import { STATUS } from '@otavamedia/om-component-library/lib/lib/request-state'
import BestProductPageLoader from '../components/general/util/BestProductPageLoader'
import { stripHTML } from '@otavamedia/om-component-library/lib/lib/utils'
import Helmet from 'react-helmet'
import Image from '../components/general/util/Image'
import { IMAGE_SIZE } from '@otavamedia/om-component-library/lib/entities/ImageModel'
import { Link } from '../components/general/util/Links'
import HTML from '@otavamedia/om-component-library/lib/util/HTML'
import application from '@otavamedia/om-component-library/lib/kea/application'
import track from 'react-tracking'
import CatchList from '../components/widgets/CatchList'

import './CatchClub.scss'
import some from 'lodash/some'

@track({ gtmContext: ['CatchClub'] })
@connect({
  actions: [
    application, [
      'setViewData',
      'setRendered'
    ]
  ],
  props: [
    application, [
      'view',
    ],
  ]
})
  /**
   * Displays a catch club page, with page content from WP, listing of latest catch cards, and a link to the catch form.
   */
class CatchClub extends Component {
  static propTypes = {
    loggedIn: PropTypes.bool,
    isMemory: PropTypes.bool,
    username: PropTypes.string,
    view: PropTypes.object,
    location: PropTypes.object,
    actions: PropTypes.object,
    compact: PropTypes.bool,
  }

  loaded = {
    main: false,
    list: false,
  }

  state = {
    categories: [],
  }

  cardsPerPage = 20

  doneLoading (element) {
    if (this.loaded[element]) {
      return
    }
    this.loaded[element] = true
    if (!some(Object.values(this.loaded), (x) => !x)) {
      this.props.actions.setRendered(true)
    }
  }

  constructor (props) {
    super(props)

    this.loadPage(props, true)
  }

  async loadPage (props, noSetState) {
    let newState
    if (props.location.pathname === '/kymppikerho/' || props.location.pathname === '/kymppikerho') {
      newState = {
        pageUrl: '/haukien-kymppikerho',
        formUrl: '/kymppikerho-lomake',
        type: 'fish',
        status: STATUS.REQUESTED
      }
    } else if (props.location.pathname === '/peurakerho/' || props.location.pathname === '/peurakerho') {
      newState = {
        pageUrl: '/peurojen-kymppikerho',
        formUrl: '/peurakerho-lomake',
        type: 'deer',
        status: STATUS.REQUESTED
      }
    } else if (props.location.pathname === '/pukkiparaati/' || props.location.pathname === '/pukkiparaati') {
      newState = {
        pageUrl: '/pukkiparaati',
        formUrl: '/pukkiparaati-lomake',
        type: 'buck',
        status: STATUS.REQUESTED
      }
    } else {
      newState = {
        pageUrl: '/hirvien-kymppikerho',
        formUrl: '/hirvikerho-lomake',
        type: 'elk',
        status: STATUS.REQUESTED
      }
    }
    if (noSetState) {
      this.state = newState
    } else {
      this.setState({ ...newState })
    }
    const postReq = await WP.getForURL(WP.url + newState.pageUrl)

    const post = postReq.data
    this.actions.setViewData(post)
    this.setState({ status: STATUS.DONE }, () => this.doneLoading('main'))
  }

  componentDidUpdate (prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.loadPage(this.props)
    }
  }

  render () {
    const { status, formUrl, type } = this.state
    const { view } = this.props

    if (status !== STATUS.ERROR && (!view || !view.id)) {
      return <BestProductPageLoader/>
    }

    const {
      content,
      title,
      excerpt,
      createdDate,
      modifiedDate,
      link,
      featuredMedia,
      ingress
    } = view

    const fullLink = window.location.origin + link
    const metaTags = {
      'og:locale': 'fi_FI',
      'og:type': 'article',
      'og:title': stripHTML(title),
      'og:description': stripHTML(excerpt),
      'og:url': fullLink,

      // og:type is article, more tags for it:
      'article:published_time': createdDate,
      'article:modified_time': modifiedDate,

      'http:status': 200,
    }
    /* eslint-disable jsx-a11y/no-onchange */
    /* eslint-disable jsx-a11y/label-has-for */
    return (
      <Fragment>
        <Helmet>
          <title>
            {`${stripHTML(title)} - ${window.om_constants.siteName}`}
          </title>
          <link rel="canonical" href={fullLink}/>
          <meta name="description" content={metaTags['og:description']}/>
          {Object.entries(metaTags).map(([key, value], i) => Array.isArray(value)
            ? (
              value.map(x => (
                <meta name={key} key={`${key}-${i}`} content={x}/>
              ))
            )
            : (
              <meta name={key} key={`${key}-${i}`} content={value}/>
            ))}
        </Helmet>
        {featuredMedia
          ? <div styleName="main-image">
            <Image data={featuredMedia} size={IMAGE_SIZE.LARGE} sizes={'(max-width: 1440px) 100vw, 1440px'}/>
          </div>
          : null
        }
        <div styleName='magazine-content'>
          <article styleName="article-container">
            <header>
              <h1>{type === 'fish' ? <FishPin/> : (type === 'elk' ? <ElkPin/> : (type === 'buck' ? null : <DeerPin/>))}<HTML>{title}</HTML></h1>
              {ingress ? <div styleName="ingress"><HTML>{ingress}</HTML></div> : null}
            </header>
            <div styleName="article-body">
              <HTML>{content}</HTML>
              <Link to={{ link: formUrl }}
                styleName="blue-button">{type === 'fish' ? 'Ilmoita haukesi' : (type === 'elk' ? 'Ilmoita hirvesi' : (type === 'deer' ? 'Ilmoita peurasi' : 'Ilmoita kaurispukkisi'))}</Link>
            </div>
          </article>
          <div styleName="catch-list">
            {type
              ? <CatchList type={type} cardsPerPage={this.cardsPerPage} showHighlight={true} withSort={true}
                doneLoading={() => this.doneLoading('list')}/>
              : null}
          </div>
        </div>
      </Fragment>
    )
    /* eslint-enable jsx-a11y/no-onchange */
    /* eslint-enable jsx-a11y/label-has-for */
  }
}

export default withRouter(CatchClub)
